import Vue from "vue";
import Vuex from "vuex";
import axios from "../axios";
import _ from "lodash";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    isAuthenicated: false,
    user: null,
    settings: null,
    appMode: -2,
    sidebar: false,
    counts: {},
    devir: {},
    doctors: {},
    fototerapi: {},
    drugs: {},
    patients: {
      servis: [],
      yb: [],
      yd: [],
    },
    khd: {},
    servisler: {
      "1": "ÇOCUK SAĞLIĞI VE HASTALIKLARI SERVİSİ",
      "2": "ÇOCUK KARDİYOLOJİ SERVİSİ",
      "3": "ÇOCUK NÖROLOJİ SERVİSİ",
      "4": "ÇOCUK ENDOKRİN SERVİSİ",
      "5": "İZOLE ÇOCUK SAĞLIĞI VE HASTALIKLARI SERVİSİ",
      "6": "YOĞUN BAKIM",
      YD: "YENİDOĞAN YOĞUN BAKIM",
    },
    servisler_kisa: {
      "1": "GENEL PEDİATRİ",
      "2": "Ç.KARDİYOLOJİ",
      "3": "Ç.NÖROLOJİ",
      "4": "Ç.ENDOKRİN",
      "5": "İZOLE SERVİS",
      "6": "YOĞUN BAKIM",
    },
    sablon: {
      ozgecmis: `PRENATAL: DM .... HT .... İLAÇ KULLANIMI .... ENFEKSİYON ÖYKÜSÜ ....\nNATAL: NVD - C/S - .... GR, KÜVÖZ ÖYKÜSÜ .... ASFİKSİ .... ÖLÇÜLERİ ....\nPOSTNATAL: FOTOTERAPİ ÖYKÜSÜ ....\nBESLENME: ANNE SÜTÜ ....\nGEÇİRDİĞİ HASTALIK: ....\nAŞILAR: .... OLDUĞU İFADE EDİLDİ. AŞI KARTI .... BCG SKARI ....\nKULLANDIĞI İLAÇLAR: .... \nALERJİ ÖYKÜSÜ: ....\nGELİŞİM BASAMAKLARI (BAŞ TUTMA, OTURMA, YÜRÜME, KONUŞMA, DİŞ ÇIKARMA): ....`,
      soygecmis: `ANNE: ....\nBABA: ....\nAKRABA EVLİLİĞİ: ....\nKARDEŞ: ....`,
      muayene: ` GENEL DURUMU : \nCİLT : \nBAŞ-BOYUN : \nKBB : \nSOLUNUM SİSTEMİ : \nKVS : \nBATIN : \nNÖROLOJİK : \nEKSTREMİTELER : \nÜROGENİTAL : `,
      ydozgecmis: `PRENATAL: ENFEKSİYON (...) DM (...) HT (...) İLAÇ KULLANIMI (...)\nANTEPARTUM KANAMA (...) ANTENATAL STEROİD : (...)\nNATAL: ....\nPOSTNATAL: ....`,
      ydsoygecmis: `ANNE ....\nBABA ....\nAKRABALIK: ....\nG: A: P: Y: KÜRTAJ VE DÜŞÜK : ....`,
      ydmuayene: `GENEL DURUMU : \nCİLT : \nBAŞ-BOYUN : \nSOLUNUM SİSTEMİ : \nKVS : \nBATIN : \nLENFATİK : \nGENİTOÜRİNER : \nEKSTREMİTELER : \nNÖROLOJİK : \n`,
      taburcu: `1. BESLENME VE AŞILAR ANLATILDI.\n2. HASTAYA 1 HAFTA SONRA ÇOCUK SAĞLIĞI VE HASTALIKLARI POLİKLİNİK KONTROLÜ ÖNERİLDİ.\n3. AİLE HEKİMLİĞİ VE ÇOCUK SAĞLIĞI POLİKLİNİK TAKİPLERİ ÖNERİLDİ.\n4. ACİL DURUMLAR ANLATILDI. DURUM DEĞİŞİKLİĞİ HALİNDE DERHAL ACİL SERVİSE BAŞVURMALARI GEREKTİĞİ ANLATILDI.`,
    },
    pdocuments: {},
    documents: {},
  },
  getters: {
    getSidebar: (state) => {
      return state.sidebar;
    },
    getServis: (state) => (id) => {
      return state.servisler[id];
    },
    getServisKisa: (state) => (id) => {
      return state.servisler_kisa[id];
    },
    getDRName: (state) => (id) => {
      return state.doctors.find((t) => t.id === id).name;
    },
    getUser: (state) => {
      return state.user;
    },
    getIsAsistan: (state) => {
      return state.user.level == 1 ? true : false;
    },
    getWelcome: (state) => {
      return {
        title: state.settings.welcometitle,
        msg: state.settings.welcome,
      };
    },
    getFototerapi: (state) => {
      return state.fototerapi;
    },
    getDrugs: (state) => {
      return state.drugs;
    },
    isLogin: (state) => {
      return state.isAuthenicated;
    },
    getAppMode: (state) => {
      return state.appMode;
    },
    getDoctors: (state) => {
      return state.doctors;
    },
    getActiveDoctors: (state) => {
      return state.doctors.filter((x) => x.active == 1);
    },
    getDocuments: (state) => {
      return state.documents;
    },
    getPDocuments: (state) => {
      return state.pdocuments;
    },
    getKHD: (state) => {
      var coombslist = _.filter(state.khd, (birth) => {
        return (
          birth.coombs != "D.Coombs (-)" &&
          birth.coombs != "" &&
          birth.durum == 0
        );
      });
      return coombslist;
    },
    getLastYatis: (state) => {
      let today = Vue.moment(new Date()).format("YYYY-MM-DD");
      return {
        servis: _.filter(state.patients.servis, { yatis: today }),
        yb: _.filter(state.patients.yb, { yatis: today }),
        yd: _.filter(state.patients.yd, { yatis: today }),
      };
    },
    getLastYD: (state) => {
      return state.last_YD;
    },
    getCounts: (state) => {
      let today = Vue.moment(new Date()).format("YYYY-MM-DD");
      var birthsToday = _.filter(state.khd, { birthdate: today });
      return {
        servis:
          state.patients.servis != undefined ? state.patients.servis.length : 0,
        yb: state.patients.yb != undefined ? state.patients.yb.length : 0,
        yd: state.patients.yd != undefined ? state.patients.yd.length : 0,
        births: birthsToday.length,
      };
    },
    getPatients: (state) => {
      return state.patients;
    },
    getTCB: (state) => {
      let result = [];
      state.patients.yd.forEach((element) => {
        result.push({ ...element, visible: false });
      });
      return result;
    },
    getSablon: (state) => {
      return state.sablon;
    },
  },
  mutations: {
    setSidebar(state, sdb) {
      state.sidebar = sdb;
    },
    setDash(state, dash) {
      state.pdocuments = dash.pdocs;
    },
    setKHD(state, p) {
      state.khd = p.khd;
    },
    setPatients(state, p) {
      state.patients.servis = p.servis;
      state.patients.yb = p.yb;
      state.patients.yd = p.yd;
      state.patients.rop = p.rop;
    },
    setDocsData(state, data) {
      state.documents = data.docs;
    },
    setPatientData(state, data) {
      var item = state.patients[data[1]].find((t) => t.id === data[0].id);
      state.patients[data[1]][item] = data[0];
    },
    setUserData(state, userdata) {
      state.user = userdata.user;
      state.doctors = userdata.doctors;
      state.settings = userdata.settings;
    },
    setAppMode(state, mode) {
      state.appMode = mode;
    },
    setAuthenicated(state, auth) {
      state.isAuthenicated = auth;
    },
    setFototerapi(state, sinirlar) {
      state.fototerapi = sinirlar;
    },
    setDrugs(state, ilaclar) {
      state.drugs = ilaclar;
    },
  },
  actions: {
    fillPatients({ commit }) {
      return axios.get("api/patients.php").then((response) => {
        commit("setPatients", response.data.data);
      });
    },
    fillKHD({ commit }) {
      return axios.get("api/khd.php").then((response) => {
        commit("setKHD", response.data.data);
      });
    },
    fillDocs({ commit }) {
      return axios.get("api/doclist.php").then((response) => {
        commit("setDocsData", response.data.data);
      });
    },
    fillDash({ commit }) {
      return axios.get("api/dash.php").then((response) => {
        commit("setDash", response.data.data);
      });
    },

    updatePatient({ commit }, veri) {
      commit("setPatientData", veri);
    },
    toggleSidebar({ commit }, veri) {
      commit("setSidebar", veri);
    },
    toggleAppMode({ commit }, veri) {
      commit("setAppMode", veri);
    },
    logoutUser({ commit }) {
      commit("setAuthenicated", false);
      commit("setUserData", {});
    },

    initializeApp({ commit }) {
      return axios
        .get("api/run.php")
        .then((response) => {
          commit("setAppMode", response.data.appMode);
        })
        .catch((response) => {
          commit("setAppMode", response.data.appMode);
        });
    },
    loginUser({ commit }) {
      return axios
        .get("api/user.php")
        .then(async (response) => {
          commit("setUserData", response.data.data);
          axios.get("api/yenidogan/fototerapi.php").then((response) => {
            commit("setFototerapi", response.data.data);
          });
          axios.get("api/drugs.php").then((response) => {
            commit("setDrugs", response.data.data);
          });
          await this.dispatch("fillPatients");
          this.dispatch("fillKHD");
          commit("setAuthenicated", true);
        })
        .catch(() => {
          commit("setAuthenicated", false);
        });
    },
  },
  modules: {},
});

export default store;
